module.exports = __webpack_public_path__ + "img/portrait-097.b8de7382.jpg";